'use client';

import {useRef} from 'react';
import {useClickAway, useKey} from 'react-use';
import {Close} from '../../icons';
import {cn} from '../../libs';
import {ModalProps} from '../../providers';

export const Modal = ({
  children,
  hideCloseButton = false,
  closeOutside = true,
  className,
  onClose,
}: ModalProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useKey('Escape', onClose);
  useClickAway(ref, (event) => {
    if (!closeOutside) return;

    const target = event.target as Element;
    if (target) {
      const isInRadixPortal = target.closest('[data-radix-popper-content-wrapper]');

      if (isInRadixPortal) {
        return;
      }
    }

    onClose?.();
  });

  return (
    <div
      ref={ref}
      className={cn('absolute w-full max-w-[480px] rounded-md bg-bg-secondary p-8', className)}
    >
      {!hideCloseButton && (
        <button
          className="absolute top-3 right-3 cursor-pointer p-1 text-text-muted transition-colors hover:text-brand-secondary-hover"
          type="button"
          onClick={onClose}
        >
          <Close className="size-6" />
        </button>
      )}
      {children}
    </div>
  );
};
